import { Link } from 'react-router-dom';
import { CapaEvento } from '@/components/ui/CapaEvento';
import { dataCurta, resumoCarteira, type CarteiraLinha } from '../utils';

interface Props {
  carteira: CarteiraLinha;
}

// Um botão grande por evento: cartaz pequeno à esquerda, nome, data e o
// resumo (fichas para retirar / ingressos). Tocar abre a carteira.
export default function CartaoCarteira({ carteira }: Props) {
  const data = dataCurta(carteira.eventoInicio);
  const resumo = resumoCarteira(carteira);
  const temFicha = carteira.paraRetirar > 0;

  return (
    <Link
      to={`/carteira/${carteira.codigo}`}
      className="aperta flex min-h-[96px] items-center gap-3 rounded-[18px] bg-background-50 p-3 shadow-pcard"
    >
      <span className="block h-[72px] w-[56px] shrink-0 overflow-hidden rounded-[10px] bg-foreground-950">
        {carteira.capa ? (
          <CapaEvento
            mobile={carteira.capa}
            desktop={carteira.capa}
            alt={carteira.eventoNome}
            preencher
            className="!rounded-[10px]"
          />
        ) : (
          <span className="flex h-full w-full items-center justify-center text-background-50/60">
            <i className="ri-coupon-3-line text-[22px]" aria-hidden />
          </span>
        )}
      </span>

      <span className="min-w-0 flex-1">
        <span className="block text-[15px] font-bold leading-snug text-foreground-950">
          {carteira.eventoNome}
        </span>
        {data && <span className="mt-0.5 block text-[13px] text-foreground-600">{data}</span>}
        <span
          className={`mt-1 block text-[13px] font-semibold ${
            temFicha ? 'text-success-700' : 'text-foreground-500'
          }`}
        >
          {resumo}
        </span>
      </span>

      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-500">
        <i className="ri-arrow-right-s-line text-xl" aria-hidden />
      </span>
    </Link>
  );
}